// import { StorageSerializers, useSessionStorage } from '@vueuse/core'

export default async <T>(url: string) => {
  // Use sessionStorage to cache data
  // const cached = useSessionStorage<T>(url, null, {
  //   serializer: StorageSerializers.object,
  // })

  // if (!cached.value) {
  try {
    const data = await $fetch<T>(url)

    //   // Update the cache
    //   cached.value = data as T
    // } else {
    //   console.log(`Getting value from cache for ${url}`)
    // }

    return data
  } catch (error: any) {
    throw createError({
      ...error,
      statusMessage: `Could not fetch data from ${url}`,
    })
  }
}
